import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { Multistep, useFieldApi } from 'informed';
import { AGENCIES_RULE_VALUE, IYupSchema, RulesStepValues, STEPS, STEPS_ICONS, STEPS_LABELS } from '../../consts';
import InformedField from '../InformedField';
import Subtitle from '../Subtitle';
import Navigation from '../Navigation';
import DualListField from '../DualListField';
import { Dropdown } from '@components';
import { DataItem } from '@common/interfaces';

interface IRulesStep {
  setYupSchema: Dispatch<SetStateAction<IYupSchema>>;
  rulesOptions: DataItem[];
  agenciesOptions: DataItem[];
}

const RulesStep: FC<IRulesStep> = ({ setYupSchema, rulesOptions, agenciesOptions }) => {
  const { setValue, getValue } = useFieldApi(STEPS.RULES);
  const stepValues = (getValue() || {}) as Partial<RulesStepValues>;
  const { global } = stepValues;
  const isAgenciesVisible = global?.value === AGENCIES_RULE_VALUE;

  useEffect(() => {
    if (global && global?.value !== AGENCIES_RULE_VALUE) setValue({ ...stepValues, agencies: [] });
  }, [global]);

  return (
    <Multistep.Step step={STEPS.RULES}>
      <Subtitle text={STEPS_LABELS.RULES} icon={STEPS_ICONS.RULES} />
      <InformedField label='Global visibility rules'>
        <Dropdown name='global' options={rulesOptions} variant='dark' placeholder='Select a preset rule' />
      </InformedField>
      {isAgenciesVisible ? (
        <InformedField>
          <DualListField
            name='agencies'
            options={agenciesOptions}
            leftTitle='List of all agencies'
            rightTitle='Selected agencies'
          />
        </InformedField>
      ) : null}
      <Navigation setYupSchema={setYupSchema} />
    </Multistep.Step>
  );
};

export default RulesStep;
